import { jwtDecode } from 'jwt-decode';

import { get, set, remove, NAMES } from './cookies';

export function decodeJWT(jwt: string) {
  const token = jwtDecode(jwt);
  return token;
}

export const validateSession = async(session: string): Promise<boolean> => {
  const jwt = decodeJWT(session);

  if (!jwt.exp) {
    return true;
  }

  const isExpired = Date.now() > jwt?.exp * 1000;
  return isExpired;
};

export const getQueryParametersAndRemove = () => {
  // Get the current URL
  const url = new URL(window.location.href);
  // Extract query parameters
  const code = url.searchParams.get('code');
  const state = url.searchParams.get('state');

  // Remove specific query parameters
  url.searchParams.delete('code');
  url.searchParams.delete('state');

  // Update the URL without reloading the page
  window.history.replaceState({}, document.title, url.toString());

  return { code, state };
};

export const getUserTokenInCookie = () => {
  if (typeof location === 'undefined') {
    return null;
  }
  const hostname = location.hostname;
  const { name } = getTokenInfo(NAMES.AUTH_TOKEN, hostname);
  return get(name);
};
export const saveUserTokenInCookie = (token: string) => {
  if (typeof location === 'undefined') {
    return null;
  }
  const hostname = location.hostname;
  const { name, domain } = getTokenInfo(NAMES.AUTH_TOKEN, hostname);
  return set(name, token, { expires: 365, domain });
};

export const removeUserTokenFromCookie = () => {
  if (typeof location === 'undefined') {
    return null;
  }
  const hostname = location.hostname;
  const { name, domain } = getTokenInfo(NAMES.AUTH_TOKEN, hostname);
  return remove(name, domain);
};

export const getTokenInfo = (tokenName: string, hostname: string) => {
  let env;
  if (hostname.includes('localhost')) {
    env = 'local';
  } else {
    const regExp = /-?([^.-]+)\.instodefi\.com$/;
    const result = regExp.exec(hostname);
    env = result ? result[1] : undefined;
  }

  if (env === 'portal') {
    env = undefined;
  }

  const domain = env === 'local' ? 'localhost' : '.instodefi.com';
  const name = `${ tokenName }${ env ? `_${ env }` : '' }`;
  return { name, domain };
};

export function sleep(time: number) {
  return new Promise((resolve) => setTimeout(resolve, time));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const checkTokenExpiration = (decodedToken: any) => {
  if (!decodedToken?.exp) {
    return false;
  }

  // Convert expiration time to milliseconds and compare with current time
  const expirationTime = decodedToken.exp * 1000;
  const currentTime = Date.now();

  return currentTime >= expirationTime;
};
